const isSameDate = (date1, date2) => Boolean(date1.day === date2.day && date1.week === date2.week);

export default isSameDate;
